module.exports = __webpack_public_path__ + "assets/img/1cc4327392366f2b6752464100846698.svg";